import * as React from "react";
import { defaultValues, toSelectOptions } from "../../../services/defaults";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";

interface Props {
  index: number;
}
export const Coralogix: React.FC<Props> = ({ index }) => {
  const df = defaultValues.org.logging.coralogix;

  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabel name={`logging.${index}.coralogix.cluster`}>Cluster</CpLabel>
          <CpSelect
            options={toSelectOptions(df.cluster.options)}
            name={`logging.${index}.coralogix.cluster`}
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.coralogix.cluster`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.coralogix.credentials`}>Credentials</CpLabel>
          <CpDescription>Select an Opaque secret to access Coralogix</CpDescription>
          <CpKindSelect
            kind="secret"
            queries={[{ property: "type", value: "opaque" }]}
            name={`logging.${index}.coralogix.credentials`}
            optionValue="name"
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.coralogix.credentials`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.coralogix.app`}>App</CpLabel>
          <CpDescription>
            <div>
              Supported variables are: <span className="font-mono">{`{org}, {gvc}, {workload}, {location}`}</span>
            </div>
          </CpDescription>
          <CpInput name={`logging.${index}.coralogix.app`} />
          <CpErrorWarning name={`logging.${index}.coralogix.app`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.coralogix.subsystem`}>Subsystem</CpLabel>
          <CpDescription>
            <div>
              Supported variables are: <span className="font-mono">{`{org}, {gvc}, {workload}, {location}`}</span>
            </div>
          </CpDescription>
          <CpInput name={`logging.${index}.coralogix.subsystem`} />
          <CpErrorWarning name={`logging.${index}.coralogix.subsystem`} />
        </CpFormItem>
      </div>
    </>
  );
};
